import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=662186e0&lang=pug&"
import script from "./highlight.vue?vue&type=script&lang=js&"
export * from "./highlight.vue?vue&type=script&lang=js&"
import style0 from "./highlight.vue?vue&type=style&index=0&id=662186e0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports